import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useModalContext } from '../../context.mjs';
import { StyledFooter } from '../../styled.mjs';
import { footer } from './footer.vanilla.mjs';

const ModalFooter = forwardRef(
  function Footer({ className: classNameFromProps, ...props }, forwardedRef) {
    const { onChangeModalFooterElement } = useModalContext("Modal.Footer");
    const composedRefs = useComposedRefs(
      forwardedRef,
      onChangeModalFooterElement
    );
    const className = classNames(footer, classNameFromProps);
    return /* @__PURE__ */ jsx(StyledFooter, { className, ref: composedRefs, ...props });
  }
);

export { ModalFooter };
//# sourceMappingURL=Footer.mjs.map
